export function reviewsSlider() {
    let $slider = $(".our-reviews-slider");

    function sliderInit() {
        $slider.slick({
            infinite: false,
            autoplaySpeed: 2000,
            arrows: false,
            autoplay: true,
            slidesToShow: 1,
            mobileFirst: true,
            dots: true,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    }

    sliderInit();

    // $(window).on("load resize", function () {
    //     if (window.innerWidth < 1024 && !$slider.hasClass("slick-initialized")) {
    //         sliderInit();
    //     }
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviewsSlider.js